(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(53678);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41120);
/* harmony import */ var _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(538);
/* harmony import */ var _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57180);








var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), {
    main: {
        background: "#f1f5f8",
        position: "relative",
        zIndex: "3",
        paddingTop: "30px"
    }
});
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles);
function Loading(props) {
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.section,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            className: classes.title,
            children: "Carregando...."
        })
    });
}


/***/ }),

/***/ 53678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81758);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_Functions_Loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24552);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41120);
/* harmony import */ var pages_sections_HeaderSection_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75994);
/* harmony import */ var _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(538);







var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(4817), __webpack_require__.e(5121), __webpack_require__.e(1788), __webpack_require__.e(7298)]).then(__webpack_require__.bind(__webpack_require__, 37298));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37298)
            ];
        }
    },
    ssr: true
});
// import FeaturedProductsSection from "pages-sections/HomePage-Sections/FeaturedProductsSection.js"
var FeaturedProductsSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 4138).then(__webpack_require__.bind(__webpack_require__, 34138));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34138)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
});
var RedeSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 4470).then(__webpack_require__.bind(__webpack_require__, 94470));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94470)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
});
var OurDifferencesSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 7700).then(__webpack_require__.bind(__webpack_require__, 77700));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77700)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
});

var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);
var SEO = {
    title: "BB Host - datacenter de qualidade!",
    description: "Datacenter de qualidade!",
    url: "https://www.bbhost.com.br/",
    type: "website"
};
var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
var __N_SSG = true;
function Index(props) {
    var classes = useStyles();
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("https://api-frontend-site.bbhost.com.br/configs", fetcher), dataConfig = ref.data;
    var ref1 = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("https://api-frontend-site.bbhost.com.br/products-featured", fetcher), dataFeaturedProducts = ref1.data;
    var ref2 = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("https://api-frontend-site.bbhost.com.br/maps", fetcher), dataIndexMap = ref2.data;
    var featuredProducts = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedProductsSection, {
        products: props.featuredProducts
    });
    var indexMap = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RedeSection, {
        map: props.indexMap
    });
    if (dataConfig) {
        if (dataConfig.featured.active && dataFeaturedProducts) featuredProducts = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedProductsSection, {
            products: dataFeaturedProducts.products
        });
        if (dataConfig.index_map.active && dataIndexMap) indexMap = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RedeSection, {
            map: dataIndexMap
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_sections_HeaderSection_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                name: "home",
                seo: SEO
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(classes.main, classes.mainRaised),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classes.container,
                    children: [
                        featuredProducts,
                        indexMap,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OurDifferencesSection, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
}


/***/ }),

/***/ 57180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21086);
/* harmony import */ var _styles_jss_bbhost_imagesStyles_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89395);




var teamStyle = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    section: {
        padding: "20px 0",
        textAlign: "center"
    },
    title: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .title */ .TN), {
        marginBottom: "1rem",
        marginTop: "30px",
        minHeight: "32px",
        textDecoration: "none"
    })
}, _styles_jss_bbhost_imagesStyles_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    itemGrid: {
        marginLeft: "auto",
        marginRight: "auto"
    },
    cardTitle: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .cardTitle */ .X5,
    smallTitle: {
        color: "#6c757d"
    },
    description: {
        color: "#999"
    },
    justifyCenter: {
        justifyContent: "center !important"
    },
    socials: {
        marginTop: "0",
        width: "100%",
        transform: "none",
        left: "0",
        top: "0",
        height: "100%",
        lineHeight: "41px",
        fontSize: "20px",
        color: "#999"
    },
    margin5: {
        margin: "5px"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (teamStyle);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4888,1758,8653,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);